import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

export const ThreadCount = styled.span`
  color: ${props => props.theme.grey800};
`;
ThreadCount.displayName = "ThreadCount";

export const ThreadTypeSwitch = styled.form`
  display: flex;
`;
ThreadTypeSwitch.displayName = "ThreadTypeSwitch";

export const ThreadTypeSwitchItem = styled.label`
  position: relative;
  & ~ & {
    margin-left: ${px2rem(15)};
    &::before {
      display: block;
      content: "";
      width: ${px2rem(1)};
      height: ${px2rem(10)};
      background-color: ${props => props.theme.grey800};
      position: absolute;
      left: ${px2rem(-7.5)};
      top: 50%;
      transform: translate3d(0, -50%, 0);
    }
  }
  & > [type="radio"] {
    position: absolute;
    left: ${px2rem(-9999)};
    opacity: 0;
    pointer-events: none;
    &:checked ~ span {
      font-weight: ${props => props.theme.weightMedium};
      color: ${props => props.theme.grey1000};
    }
  }
  & > span {
    color: ${props => props.theme.grey700};
    font-size: ${px2rem(12)};
  }
`;
